import { Injectable } from '@angular/core';
import { CorporateLicenceType, CreateMutOutput, MySironaGetCorporateLicenceDetailedDto, MySironaGetCorporateLicenceDto, MySironaGetSponsorshipDataDto, MySironaLegitimatedUser, MySironaLegitimationServiceProxy, MySironaSponsorshipServiceProxy } from '@shared/service-proxies/service-proxies';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MySironaSponsorshipService {
  sponsorshipId: number;
  sponsorshipDataCached: MySironaGetSponsorshipDataDto;

  constructor(
    private readonly mySironaSponsorshipServiceProxy: MySironaSponsorshipServiceProxy,
  ) {}

  public setSponsorshipId(id: number): void {
    this.sponsorshipId = id;
    this.sponsorshipDataCached = undefined; // Clear cached data when setting a new sponsorship ID
  }

  public getSponsorshipData(): Observable<MySironaGetSponsorshipDataDto> {
    if (this.sponsorshipDataCached !== undefined) {
      return of(this.sponsorshipDataCached);
    }

    return this.mySironaSponsorshipServiceProxy
      .getSponsorshipData(this.sponsorshipId)
      .pipe(tap((x) => (this.sponsorshipDataCached = x)));
  }

  public getLicencesForSponsorship(sponsorshipId?: number, licenceType?: CorporateLicenceType): Observable<MySironaGetCorporateLicenceDto[]> {
    sponsorshipId = sponsorshipId ?? this.sponsorshipId;
    return this.mySironaSponsorshipServiceProxy.getLicencesForSponsorship(sponsorshipId, licenceType);
  }

  public getCorporateLicence(licenceId: number): Observable<MySironaGetCorporateLicenceDetailedDto> {
    return this.mySironaSponsorshipServiceProxy.getCorporateLicence(licenceId);
  }

  public hasSponsorshipMutApplications(): Observable<number> {
    return this.mySironaSponsorshipServiceProxy.hasSponsorshipMutApplications(this.sponsorshipId);
  }

  public createMut(mutationType: string, corporateLicenceId: number): Observable<CreateMutOutput> {
    return this.mySironaSponsorshipServiceProxy.createMut(mutationType, this.sponsorshipId, corporateLicenceId);
  }

  public getLegitimatedAdmins(): Observable<MySironaLegitimatedUser[]> {
    return this.mySironaSponsorshipServiceProxy.getLegitimations(this.sponsorshipId, true);
  }

  public getLegitimatedUsers(): Observable<MySironaLegitimatedUser[]> {
    return this.mySironaSponsorshipServiceProxy.getLegitimations(this.sponsorshipId, false);
  }
}
